import Motion from '@/app/components/Motion';

import DesktopTestimonialCard from './DesktopTestimonialCard';
import type {
  LandingPageTestimonial,
  LandingPageTestimonialsTheme,
} from './types';

export interface DesktopTestimonialCardsProps {
  readonly activeIndex: number;
  readonly inverted: boolean;
  readonly onActiveIndexChange: (index: number) => void;
  readonly testimonials: LandingPageTestimonial[];
  readonly theme: LandingPageTestimonialsTheme;
}

const DesktopTestimonialCards = ({
  activeIndex,
  inverted,
  onActiveIndexChange,
  testimonials,
  theme,
}: DesktopTestimonialCardsProps): JSX.Element => {
  return (
    <Motion
      className="hidden lg:flex lg:justify-center"
      initial={{ opacity: 0, filter: 'blur(5px)' }}
      whileInView={{ filter: 'blur(0px)', opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1, delay: 0.5 }}
    >
      {testimonials.map((testimonial, i) => (
        <DesktopTestimonialCard
          key={testimonial.id}
          {...testimonial}
          activeIndex={activeIndex}
          index={i}
          inverted={inverted}
          numberOfTestimonials={testimonials.length}
          onActiveIndexChange={onActiveIndexChange}
          theme={theme}
        />
      ))}
    </Motion>
  );
};

export default DesktopTestimonialCards;
